import React from 'react'
import { styled, Typography } from '@mui/material'
import ButtonWithIcon from '@zuto/atoms/src/ButtonWithIcon/ButtonWithIcon'
import { convertToKebabCase } from '../../../../../src/utils/utils'

type DataSectionProps = {
  title: string
  children: React.ReactNode
  hideDivider?: boolean
  onClick?: React.MouseEventHandler<HTMLDivElement>
  showButton?: boolean
}

const DataSectionContainer = styled('div')({})

const Divider = styled('hr')({
  borderTop: 'none',
  borderBottom: '1px solid #CCC',
  margin: '0 -16px 16px -16px'
})

const DataSection = ({
  title,
  children,
  hideDivider,
  onClick,
  showButton = true
}: DataSectionProps): JSX.Element => {
  const testId = convertToKebabCase(title)

  return (
    <DataSectionContainer>
      <div className="data-row">
        <div className="heading">
          <Typography variant="h3">{title}</Typography>
        </div>
        {showButton && (
          <div className="content" data-hj-suppress="">
            <ButtonWithIcon testId={`edit-${testId}`} onClick={onClick} />
          </div>
        )}
      </div>
      {children}
      {!hideDivider && <Divider data-testid={`${testId}-divider`} />}
    </DataSectionContainer>
  )
}

export default DataSection
